import { Box, TextField } from "@mui/material";

interface Props {
	search: string;
	onSearchChange: (value: string) => void;
}

// No "Add" button: the parameter set is fixed (from the tag catalog); this page
// only edits each parameter's limits.
export const StraightenerLimitsToolbar = ({
	search,
	onSearchChange,
}: Props) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
		<TextField
			size="small"
			placeholder="Search..."
			value={search}
			onChange={(e) => onSearchChange(e.target.value)}
			sx={{ width: 220 }}
		/>
	</Box>
);
